/* unplugin-vue-components disabled */var render = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('Popup', {
    attrs: {
      "width": "100%",
      "position": "right",
      "show-mask": false
    },
    model: {
      value: _vm.currValue,
      callback: function ($$v) {
        _vm.currValue = $$v;
      },
      expression: "currValue"
    }
  }, [_c('view-box', {
    ref: "viewBox",
    attrs: {
      "body-padding-bottom": 0
    }
  }, [_c('XHeader', {
    attrs: {
      "left-options": {
        preventGoBack: true
      }
    },
    on: {
      "on-click-back": function ($event) {
        _vm.currValue = false;
      }
    }
  }, [_vm._v(_vm._s(_vm.title))]), _c('div', {
    ref: "mymap",
    attrs: {
      "id": "mymap_view"
    }
  })], 1)], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };